import { toolKeys } from '@lbmx/types';

const routePermissions: { [key: string]: toolKeys | toolKeys[] } = {
  '/PIMModule': toolKeys.PIM,
  '/MarketplacePartnersModule': [
    toolKeys.MPP,
    toolKeys.PIM_CROSS_REFERENCES,
    toolKeys.PDX_CROSS_REFERENCES,
  ],
  '/AdministrationModule': toolKeys.ADMINISTRATION,
  '/administration-module': toolKeys.ADMINISTRATION,
  '/MarketplaceModule': toolKeys.MP,
  '/pay-module': toolKeys.MP_INVOICE_PAY,
  '/ediModule': toolKeys.ANALYTICS,
  '/userProfile': toolKeys.AUTHENTICATED,
  '/analytics-module': toolKeys.ANALYTICS,
};

export default routePermissions;
